// extracted by mini-css-extract-plugin
module.exports = {"horizontalCard":"horizontal-card-module--horizontalCard--1YX-p","title":"horizontal-card-module--title--1D8fe"};